module.exports = __webpack_public_path__ + "static/img/6300_phase_function_Paper_Points.1b2c135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6300_phase_function_Paper_Points.png
// module id = /vWx
// module chunks = 0